import React from "react";
import { Row, Col, Button, Input, Message, Text, CheckPicker } from "rsuite";
import { Container } from "react-bootstrap";
import { AirplaneFill, CaretDownFill, CarFrontFill, Pen, GeoAltFill } from "react-bootstrap-icons";
import { useOrderCreation } from "../context/OrderCreationContext";
import { OrderType } from "../../../../../my-enum";
import { useGetAirlines } from "../../../../../hooks/Airline";
import { SPECIAL_REQUESTS } from "../../../../../my-type";

export const TripSettings: React.FC = () => {
  const {
    orderType,
    rideTime,
    selectedAdress,
    selectedTerminal,
    estArriveTime,
    flightSchedule,
    flightNo,
    flightTime,
    isRidetimeTooLateOrEarly,
    setStep,
    vehicleServiceBasicFee,
    addServiceFee,
    rideDateType,
    displayRegistedLuggage,
    userVehicle,
    adultCount,
    babyCount,
    getTotalFee,
    viaPoints,
    segmentDistances,
    specialRequests,
    setSpecialRequests,
    meetAndGreetDetails,
    setMeetAndGreetDetails,
    refLuggageNote,
    luggageNote,
    setLuggageNote
  } = useOrderCreation();

  const { airlines } = useGetAirlines();

  return (
    <Container fluid="md" style={{ backgroundColor: 'white' }} className="rounded">
      <br />
      <Row>
        <Col style={{ textAlign: 'left' }}>
          <h5>您的{orderType === OrderType.送機 ? '送機' : '接機'}計劃</h5>
        </Col>
      </Row>
      <br />

      <Row>
        <Col xs={2}><CarFrontFill /></Col>
        <Col style={{ textAlign: 'left' }} xs={19}>
          {rideTime?.toLocaleString().substring(0, rideTime?.toLocaleString().length - 3)} 乘車時間
          <br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>
            {orderType === OrderType.送機 ? selectedAdress : selectedTerminal?.name}
          </span>
        </Col>
        <Col xs={2}><Pen onClick={() => setStep(0)} /></Col>
      </Row>
      <br />

      {flightNo && orderType === OrderType.接機 && (
        <>
          <Row>
            <Col xs={2}><AirplaneFill /></Col>
            <Col style={{ textAlign: 'left' }} xs={19}>
              航班編號 {flightNo}
              <br />
              <span style={{ color: 'GrayText', fontSize: '12px' }}>
                {flightTime ? `航班抵達時間: ${flightTime.toLocaleString().substring(0, flightTime.toLocaleString().length - 3)}` : '提供給司機參考'}
              </span>
            </Col>
            <Col xs={2} />
          </Row>
          <br />
        </>
      )}

      {/* Display Via Points if available */}
      {viaPoints && viaPoints.length > 0 && viaPoints.some(point => point.trim() !== '') && (
        <>
          {viaPoints.map((viaPoint, index) => (
            viaPoint.trim() !== '' && (
              <React.Fragment key={index}>
                <Row>
                  <Col xs={2}><GeoAltFill /></Col>
                  <Col style={{ textAlign: 'left' }} xs={19}>
                    經由地點 {index + 1}
                    <br />
                    <span style={{ color: 'GrayText', fontSize: '12px' }}>
                      {viaPoint}
                    </span>
                  </Col>
                  <Col xs={2} />
                </Row>
                <br />
              </React.Fragment>
            )
          ))}
        </>
      )}

      <Row>
        <Col xs={2}><CaretDownFill /></Col>
        <Col style={{ textAlign: 'left' }} xs={19}>
          {estArriveTime?.toLocaleString().substring(0, estArriveTime?.toLocaleString().length - 3)} 下車時間(預估)
          <br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>
            {orderType === OrderType.送機 ? selectedTerminal?.name : selectedAdress}
          </span>
        </Col>
        <Col xs={2} />
      </Row>
      <br />

      {flightSchedule && (
        <>
          <Row>
            <Col xs={2}><AirplaneFill /></Col>
            <Col style={{ textAlign: 'left' }} xs={19}>
              航班編號 {flightSchedule.FlightNumber}
              <br />
              <span style={{ color: 'GrayText', fontSize: '12px' }}>
                {airlines.find(element => element.airlineID === flightSchedule?.AirlineID)?.airlineName.zh_tw} /
                {orderType === OrderType.送機 ? '起飛' : '抵達'} {orderType === OrderType.送機 ? flightSchedule.DepartureTime : flightSchedule.ArrivalTime} /
                {flightSchedule.Terminal}航廈
              </span>
            </Col>
            <Col xs={2} />
          </Row>
          <br />
          {isRidetimeTooLateOrEarly && (
            <>
              <Row>
                <Col xs={2} />
                <Col style={{ textAlign: 'left' }}>
                  <Message showIcon type="warning">
                    <Text color="red">
                      請確認搭車時間，建議搭乘時間為{orderType === OrderType.送機 ? "班機起飛前一小時" : "班機抵達後40分鐘"}
                    </Text>
                  </Message>
                </Col>
                <Col xs={2} />
              </Row>
              <br />
            </>
          )}
        </>
      )}

      <Row>
        <Col style={{ textAlign: 'left' }}><h5>車種及人數</h5></Col>
      </Row>
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }} xs={21}>
          {userVehicle ? userVehicle.vehiclename : ''}．{adultCount}乘客．{babyCount}兒童
          <br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>{displayRegistedLuggage(true)}</span>
        </Col>
        <Col xs={2}><Pen onClick={() => setStep(2)} /></Col>
      </Row>
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }}><h5>車資計算</h5></Col>
      </Row>
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }} xs={6}>
          基本費用<br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>
            {orderType === OrderType.送機
              ? vehicleServiceBasicFee!.price
              : vehicleServiceBasicFee!.price + vehicleServiceBasicFee!.pickUpPrice}
          </span>
          <br />
        </Col>
        <Col style={{ textAlign: 'left' }} xs={6}>
          偏遠路段<br />
          <span style={{ color: 'GrayText', fontSize: '12px' }}>{addServiceFee}</span>
        </Col>
        {rideDateType !== 0 && (
          <Col style={{ textAlign: 'left' }} xs={6}>
            假日加價<br />
            <span style={{ color: 'GrayText', fontSize: '12px' }}>
              {rideDateType === 1
                ? vehicleServiceBasicFee!.holidayPrice
                : vehicleServiceBasicFee!.holidayPrice + 300}
            </span>
          </Col>
        )}
        {(rideTime.getHours() < 7 || rideTime.getHours() >= 23) && (
          <Col style={{ textAlign: 'left' }} xs={6}>
            夜間服務費<br />
            <span style={{ color: 'GrayText', fontSize: '12px' }}>200</span>
          </Col>
        )}
        {meetAndGreetDetails && meetAndGreetDetails.trim() !== '' && (
          <Col style={{ textAlign: 'left' }} xs={6}>
            接機舉牌服務<br />
            <span style={{ color: 'GrayText', fontSize: '12px' }}>200</span>
          </Col>
        )}
        {segmentDistances && segmentDistances.length > 0 && viaPoints && (() => {
          // Filter viaPoints to get non-empty ones
          const filteredViaPoints = viaPoints.filter(point => point.trim() !== '');

          // Only calculate fee for segments that drop off at via points
          // For 送機: segments that end at via points (not the final terminal segment)
          // For 接機: segments that start from via points (not the initial terminal segment)
          const totalSegmentFee = segmentDistances.reduce((total, distanceMeters, index) => {
            let shouldIncludeFee = false;

            if (orderType === OrderType.送機) {
              // For drop-off: include segments ending at via points (index < filteredViaPoints.length)
              shouldIncludeFee = index < filteredViaPoints.length;
            } else {
              // For pickup: include segments starting from via points (skip first segment from terminal)
              shouldIncludeFee = index > 0;
            }

            if (shouldIncludeFee) {
              const distanceKm = distanceMeters / 1000;
              console.log('Segment', index, 'Distance (km):', distanceKm);
              if (distanceKm >= 5) return total + 500;
              if (distanceKm >= 3) return total + 200;
            }
            return total;
          }, 0);

          return totalSegmentFee > 0 ? (
            <Col style={{ textAlign: 'left' }} xs={6}>
              中途點加價<br />
              <span style={{ color: 'GrayText', fontSize: '12px' }}>{totalSegmentFee}</span>
            </Col>
          ) : null;
        })()}


      </Row>
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }} xs={6}>
          車資總額<br />
          <span style={{ color: 'blue', fontSize: '16px' }}>${getTotalFee()}</span>
        </Col>
      </Row>
      <br />
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }}><h5>特殊需求</h5></Col>
      </Row>
      <br />

      <Row>
        <Col xs={24}>
          <div style={{ position: 'relative' }}>
            <CheckPicker
              data={SPECIAL_REQUESTS}
              value={specialRequests}
              onChange={value => setSpecialRequests(value || [])}
              style={{ width: "100%" }}
              placeholder="請選擇特殊需求（可多選）"
              searchable={false}
              block
              preventOverflow
            />
          </div>
        </Col>
      </Row>
      <br />
      <br />

      {orderType === OrderType.接機 && (
        <>
          <Row>
            <Col style={{ textAlign: 'left' }}><h5>接機舉牌資訊</h5></Col>
          </Row>
          <Row>
            <Col xs={23}>
              <Input
                as="textarea"
                rows={2}
                value={meetAndGreetDetails}
                onChange={(value) => setMeetAndGreetDetails(value)}
                placeholder="例如：舉牌顯示姓名、公司名稱等"
              />
              <Text muted size="sm" style={{ fontSize: '12px', marginTop: '4px', display: 'block' }}>
                用於司機接機時舉牌顯示的資訊
              </Text>
            </Col>
          </Row>
          <br />
          <br />
        </>
      )}

      <Row>
        <Col style={{ textAlign: 'left' }}><h5>乘車備註</h5></Col>
      </Row>
      <Row>
        <Col xs={23}>
          <Input
            ref={refLuggageNote}
            as="textarea"
            rows={3}
            defaultValue={luggageNote}
            onChange={(value) => setLuggageNote(value)}
          />
        </Col>
      </Row>
      <br />
      <br />


      <Row>
        <Col xs={19} />
        <Col style={{ textAlign: 'right', marginBottom: '15px' }}>
          <Button appearance="primary" color="yellow" onClick={() => setStep(5)}>
            下一步
          </Button>
        </Col>
      </Row>
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
};
